module.exports = __webpack_public_path__ + "static/media/all-epic.780462c2.mp3";